var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"899b94528fd203bf73c29c2ce0d73ee090a6fe06"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { resolveEnv } from "./environment";

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || "",
	// 現在のオリジンから環境を判定する
	environment: resolveEnv(),
	tracesSampleRate: 0
});
